import { tickerItems } from "@/mocks/ticker";

export default function Ticker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section aria-label="最新测评快讯" className="w-full border-y border-background-200 bg-foreground-950">
      <div className="mx-auto flex w-full max-w-6xl items-center gap-3 px-4 py-3 md:px-8">
        <span className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
          <i className="ri-live-line" aria-hidden="true" />
          实时快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8">
            {loopItems.map((item, index) => (
              <span
                key={`${item.id}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-background-100 md:text-sm"
              >
                <i className="ri-time-line text-accent-400" aria-hidden="true" />
                <span className="text-background-300">{item.time}</span>
                <span>{item.text}</span>
                <em className="not-italic rounded-full bg-background-50/10 px-2 py-0.5 text-[11px] text-accent-300">
                  {item.tag}
                </em>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}